<script>
/* import {
    SeriesCollectionDirective,
    SeriesDirective,
    AccumulationSeriesCollectionDirective,
    AccumulationSeriesDirective
} from "@syncfusion/ej2-vue-charts"; */
import {
    SeriesCollectionDirective,
    SeriesDirective
} from "@syncfusion/ej2-vue-charts/src/chart/series.directive";
import {
    AccumulationSeriesCollectionDirective,
    AccumulationSeriesDirective
} from "@syncfusion/ej2-vue-charts/src/accumulation-chart/series.directive";

import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { library } from "@common/library/library";
import { componentStore } from "@common/componentStore/componentStore";
import { configStore } from "@common/configStore";
import settingsEditor from "@common/settingsEditor/settingsEditor";
import { actionStore } from "@common/actionStore";

const chartConfig = {
    cId: "chart",
    cType: "chart",
    cTitle: "Chart",
    cTemplate: `<div :id="cId" class="chart" :class="{'condensed-chart':condenseChart}" v-if="!configReload && config" :style="componentStyles">
        <div v-if="condenseChart">
            <div v-for="point in condensedDisplayData" @click="popupChart" class="condensed-data-point">{{point.pointValue}}</div>
        </div>
        <div v-else>
            <div v-if="chartRenderType === 'count'" :style="{width:config.chartWidth}">
            <p class="chart-title" v-if="!config.hideChartTitle" :style="chartTitleStyles">{{config.chartTitle}}</p>
            <div v-for="(series, seriesIndex) in config.countSeries" :class="'count-series-container series-' + seriesIndex">
                <p class="count-series-title" v-if="!series.hideSeriesTitle">{{series.seriesTitle}}</p>
                <div class="count-box-container" :class="countBoxContainerClasses" v-if="hasDisplayData">
                    <div v-for="(countItem, countIndex) in series.countList">
                        <div
                            class="chart-count-box"
                            :class="countBoxStyles[seriesIndex][countIndex].boxClasses"
                            :style="countBoxStyles[seriesIndex][countIndex].box"
                            @click="selectPoint(countItem)"
                        >
                            <img v-if="getImagePosition(countItem.countItemImageSettings) === 'topLeft'" :src="countItem.countItemImageSettings.imageFile" :style="countBoxStyles[seriesIndex][countIndex].image" />
                            <div class="count-box-text-container">
                                <div class="count-box-item-count" :style="countBoxStyles[seriesIndex][countIndex].number">
                                    <span v-if="!countItem.labelFormat && countItem.prefixUnit">{{countItem.prefixUnit}}</span>
                                    {{ formattedDisplaySeriesData['series_' + seriesIndex][countIndex]['pointValue'] }}
                                    <span v-if="!countItem.labelFormat && countItem.postfixUnit">{{countItem.postfixUnit}}</span>
                                </div>
                                <div class="count-box-item-label"
                                    :style="countBoxStyles[seriesIndex][countIndex].title"
                                >
                                    <div>{{countItem.countTitle}}</div>
                                    <div class="count-sub-title" v-if="countItem.countSubTitle">{{countItem.countSubTitle}}</div>
                                </div>
                            </div>
                            <img v-if="getImagePosition(countItem.countItemImageSettings) === 'bottomRight'" :src="countItem.countItemImageSettings.imageFile" :style="countBoxStyles[seriesIndex][countIndex].image"/>
                        </div>
                        <div v-if="countItem.countSubActionText" :class="countBoxStyles[seriesIndex][countIndex].action"><button type="button" class="count-item-btn-link" :title="countItem.countSubActionText"  @click="selectPoint(countItem)">{{countItem.countSubActionText}}</button></div>
                    </div>
                </div>
            </div>
        </div>
            <div v-if="chartRenderType === 'chart' && displaySeriesData">
                <ejs-chart :id="cId"
                    :width="config.chartWidth"
                    :height="config.chartHeight"
                    :title="!config.hideChartTitle && config.chartTitle"
                    :primaryXAxis="config.primaryXAxis"
                    :primaryYAxis="config.primaryYAxis"
                    :titleStyle="chartTitleStyles"
                    :palettes="colorPalette"
                    :tooltip="tooltip"
                    :pointRender="pointRender"
                    :chartArea="config.chartArea"
                    :legendSettings="config.legendSettings"
                    :background="chartBackground"
                    selectionMode="Point"
                    :pointClick="pointClick"
                    :useGroupingSeparator="dataFormat==='number'"
                    :ref="cId"
                >
                    <e-series-collection>
                        <e-series v-for="(series, index) in config.countSeries"
                            :dataSource="displaySeriesData['series_' + index]"
                            :name="series.hideSeriesTitle ? undefined : series.seriesTitle"
                            :type="config.type"
                            :legendShape="config.legendSettings && config.legendSettings.legendShape ? config.legendSettings.legendShape : 'seriesType'"
                            xName="pointLabel"
                            yName="pointValue"
                            :marker="marker"
                        ></e-series>
                    </e-series-collection>
                </ejs-chart>
            </div>
            <div v-if="chartRenderType === 'accumulation' && displaySeriesData">
            <p class="chart-title" v-if="!config.hideChartTitle" :style="chartTitleStyles">{{config.chartTitle}}</p>
                <ejs-accumulationchart
                    :tooltip="tooltip"
                    :pointRender="pointRender"
                    :chartArea="config.chartArea"
                    :background="chartBackground"
                    :height="config.chartHeight"
                    :legendSettings="config.legendSettings && config.legendSettings"
                    selectionMode="Point"
                    :pointClick="pointClick"
                    :useGroupingSeparator="dataFormat==='number'"
                    :enableSmartLabels="true"
                    :ref="cId"
                >
                    <e-accumulation-series-collection>
                        <e-accumulation-series v-for="(series, index) in config.countSeries"
                            :dataSource="displaySeriesData['series_' + index]"
                            xName="pointLabel"
                            yName="pointValue"
                            :pointColorMapping="'fill'"
                            :legendShape="config.legendSettings && config.legendSettings.legendShape ? config.legendSettings.legendShape : 'seriesType'"
                            :innerRadius="config.pieSettings && config.pieSettings.innerRadius"
                            :palettes="piePalette"
                            :marker="marker" :border="config.pieSettings && config.pieSettings.border"
                            :dataLabel="pieDataLabel"
                        ></e-accumulation-series>
                    </e-accumulation-series-collection>
                </ejs-accumulationchart>
            </div>
        </div>
    </div>`
};

const fieldsObj = {
    text: 'text',
    value: 'value'
};

const fontList = [
    { text: 'Proxima Nova', value: 'proxima-nova' },
    { text: 'Open Sans', value: 'Open Sans' },
    { text: 'Source Serif Pro', value: 'Source Serif Pro' },
    { text: 'Schoolbook', value: 'Schoolbook' },
    { text: 'Arial', value: 'Arial' },
    { text: 'Times New Roman', value: 'Times New Roman' },
    { text: 'Courier New', value: 'Courier New' },
    { text: 'Brush Script MT', value: 'Brush Script MT' },
];

const fontWeights = [
    { text: 'Light 300', value: '300' },
    { text: 'Regular 400', value: '400' },
    { text: 'Semi-bold 600', value: '600' },
    { text: 'Bold 700', value: '700' },
    { text: 'Extra-bold 800', value: '800' },
];

const smallFontSizes = [
    { text: '12px', value: '12px' },
    { text: '14px', value: '14px' },
    { text: '16px', value: '16px' }
];

const mediumFontSizes = [
    { text: '18px', value: '18px' },
    { text: '20px', value: '20px' },
];

const largeFontSizes = [
    { text: '24px', value: '24px' },
    { text: '28px', value: '28px' },
    { text: '36px', value: '36px' },
];

const fontColors = [
    { text: 'Samaritan Blue', value: '#08538a' },
    { text: 'Samaritan Aqua', value: '#82cdd3' },
    { text: 'Warm Gray Dark', value: '#635d5c' },
    { text: 'Warm Gray Light', value: '#a6a2a0' },
    { text: 'Black', value: '#000' }
];

const white = [
    { text: 'White', value: '#ffffff' }
];

const colorPalettes = [
    { text: 'Default Colors', value: 'default', palette: ['#444e86', '#dd5182', '#ffa600'] },
    { text: 'Blues', value: 'Blues', palette: ['#08538a', '#3490b2', '#82cdd3'] },
    { text: 'Samaritan', value: 'Samaritan', palette: ['#82cdd3', '#f8de46', '#08538a'] },
    { text: 'Primary', value: 'Primary', palette: ['#08538a', '#f8de46', '#B80F0A'] },
    { text: 'Greys', value: 'Greys', palette: ['#635d5c', '#a6a2a0', '#dbd6d3'] },
    { text: 'Blush', value: 'blush', palette: ['#665858', '#b08787', '#ffb8b8'] }
];

// const singleColorPalette = [
//     { text: 'Samaritan Blue', value: 'Samaritan Blue', palette: ['#08538a'] },
//     { text: 'Samaritan Aqua', value: 'Samaritan Aqua', palette: ['#82cdd3'] },
//     { text: 'Red', value: 'Red', palette: ['#B80F0A'] }
// ];

const threeColorPalettes = [
    { text: 'Default Colors', value: 'default', palette: ['#955196', '#dd5182', '#ff6e54'] },
    { text: 'Blues', value: 'Blues', palette: ['#08538a', '#3490b2', '#82cdd3'] },
    { text: 'Samaritan Colors', value: 'Samaritan Colors', palette: ['#82cdd3', '#f8de46', '#08538a'] },
    { text: 'Muted Darks', value: 'Muted Darks', palette: ['#252e5c', '#802344', '#bd820f'] },
    { text: 'Warm Grays', value: 'Warm Grays', palette: ['#635d5c', '#a6a2a0', '#dbd6d3'] },
    { text: 'Blush', value: 'Blush', palette: ['#665858', '#b08787', '#ffb8b8'] },
    { text: 'Greens', value: 'Greens', palette: ['#445525', '#84a14f', '#c8e595'] },
    { text: 'Primary', value: 'Primary', palette: ['#08538a', '#f8de46', '#B80F0A'] },
];

const fiveColorPalettes = [
    { text: 'Default Colors', value: 'default', palette: ['#444e86', '#955196', '#dd5182', '#ff6e54', '#ffa600'] },
    { text: 'Blues', value: 'blue', palette: ['#08538a', '#1372a0', '#3490b2', '#59afc3', '#82cdd3'] },
    { text: 'Samaritan Colors', value: 'Samaritan Colors', palette: ['#82cdd3', '#f8de46', '#a6a2a0', '#635d5c', '#08538a'] },
    { text: 'Muted Darks', value: 'Muted Darks', palette: ['#252e5c', '#511c52', '#802344', '#a33927', '#bd820f'] },
    { text: 'Warm Grays', value: 'Warm Grays', palette: ['#443e3b', '#635d5c', '#a19792', '#c1b7b2', '#d7cdc7', '#f5ebe6'] },
    { text: 'Blush', value: 'Blush', palette: ['#665858', '#8a6f6f', '#b08787', '#d79f9f', '#ffb8b8'] },
    { text: 'Greens', value: 'Greens', palette: ['#445525', '#52721d', '#7a9c3c', '#b4d771', '#d5eea4'] },
    { text: 'Primary', value: 'Primary', palette: ['#08538a', '#088a45', '#f8de46', '#f88a46', '#B80F0A', '#500ab8'] }
];

const editorSettings = {
    DocumentationUrl: { type: "URL", text: "Chart Documentation", url: "https://samaritan.atlassian.net/wiki/spaces/DEVELOPMEN/pages/650870975/Chart+Component" },
    quickStartText: {
        type: 'info',
        text: `
            <ul>
                <li>
                    <strong>Step 1: Create a Dataset for your chart</strong><br/>
                    Before creating your chart you need a data.
                </li>
                <li>
                    <strong>Step 1: Select a type of chart</strong><br/>
                    Such as Pie or Bar chart.
                </li>
                <li>
                    <strong>Step 2: Create a Value Series</strong><br/>
                    A Value Series is a grouping of values eg: "This year" vs "last year".
                    Where "this year" will have multiple chart values.
                </li>
                <li>
                    <strong>Step 4: Create Chart Values</strong><br/>
                    Chart values are individual values accumulated from the data. eg: "dogs adopted" and "cats adopted".
                </li>
            </ul>`
    },
    quickStartPanel: {
        id: 'quickStartPanel',
        type: 'panel',
        label: 'Quickstart',
        fields: [
            'DocumentationUrl',
            'quickStartText',
            'type',
            'countSeries.seriesTitle',
            'countSeries.datasetIds',
            'countSeries.countList'
        ]
    },
    typeSizeSettingsPanel: {
        type: 'panel',
        label: 'Chart Type & Size',
        id: 'typeSizeSettingsPanel',
        fields: [
            'type',
            'countBoxArrangement',
            'chartWidth',
            'chartHeight'
        ]
    },
    chartValuePanel: {
        type: 'panel',
        label: 'Chart Value Settings',
        id: 'chartValuePanel',
        fields: [
            'countSeries',
        ]
    },
    styleSettings: {
        type: 'panel',
        label: 'Color & Style Settings',
        id: 'styleSettings',
        fields: [
            'useDefaultColors',
            'datapointStyles',
            'colorPalette',
            'piePalette',
            'chartArea'
        ],
        logic: [
            {
                record: 'self.object1',
                prop: 'display',
                valueType: 'criteria',
                criteria: 'this.valuesMap.type && this.valuesMap.type !== "Count"'
            }
        ],
    },
    titleSettingsPanel: {
        type: 'panel',
        label: 'Chart Title Settings',
        id: 'titleSettingsPanel',
        fields: [
            'hideChartTitle',
            'chartTitle',
            'chartTitleStyleSettings'
        ]
    },
    axisSettingsPanel: {
        type: 'panel',
        label: 'Column, Line & Bar Axis Settings',
        id: 'axisSettingsPanel',
        logic: [
            {
                record: 'self.object1',
                prop: 'display',
                valueType: 'criteria',
                criteria: 'this.valuesMap.type && (this.valuesMap.type === "Column"  || this.valuesMap.type === "Bar"  || this.valuesMap.type === "Line")'
            }
        ],
        fields: [
            'primaryXAxis',
            'primaryYAxis'
        ]
    },
    legendSettingsPanel: {
        type: 'panel',
        label: 'Legend Settings',
        id: 'legendSettingsPanel',
        fields: [
            'legendSettings'
        ],
        logic: [
            {
                record: 'self.object1',
                prop: 'display',
                valueType: 'criteria',
                criteria: 'this.valuesMap.type && this.valuesMap.type !== "Count"'
            }
        ],
    },
    pieSettingsPanel: {
        type: 'panel',
        label: 'Pie Chart Settings',
        id: 'pieSettingsPanel',
        // display: true,
        logic: [
            {
                record: 'self.object1',
                prop: 'display',
                valueType: 'criteria',
                criteria: 'this.valuesMap.type && this.valuesMap.type === "Pie"'
            }
        ],
        fields: [
            'pieSettings'
        ],
    },
    colorPalette: {
        type: 'dropdown',
        label: 'Column/Bar Chart Color Palettes',
        helpText: 'Choose from a variety of custom color palettes.',
        id: 'colorPalette',
        fields: fieldsObj,
        items: threeColorPalettes,
        logic: [
            {
                record: 'self',
                prop: 'display',
                valueType: 'criteria',
                criteria: 'this.valuesMap.type === "Column" || this.valuesMap.type === "Bar"'
            }
        ],
    },
    piePalette: {
        type: 'dropdown',
        label: 'Color Palettes for Pie Charts',
        helpText: 'Choose from a variety of custom color palettes.',
        id: 'piePalette',
        fields: fieldsObj,
        items: fiveColorPalettes,
        logic: [
            {
                record: 'self',
                prop: 'display',
                valueType: 'criteria',
                criteria: 'this.valuesMap.type === "Pie"'
            }
        ],
    },
    chartArea: {
        type: 'OBJECT',
        label: 'Overall Chart Area Settings',
        helpText: 'Settings for the chart area.',
        default: {
            background: '#FFFFFF',
        },
        id: 'chartArea',
        properties: {
            opacity: {
                type: 'number',
                label: 'Chart Opacity',
                helpText: 'Opacity of the overall chart.',
                default: 1,
                id: 'opacity'
            },
            chartBackground: {
                type: 'pie',
                label: 'Chart Background Color',
                helpText: 'Overall background color of the chart',
                default: '#ffffff',
                id: 'chartBackground'
            },
            background: {
                type: 'color',
                label: 'Data Area Background Color',
                helpText: 'Background color of the chart\'s data area.',
                default: '#ffffff',
                id: 'background'
            }
            // backgroundImage: {
            //     type: 'text',
            //     label: 'Background Image Url',
            //     helpText: 'Enter a URL for a background Image',
            //     default: null,
            //     id: 'backgroundImage'
            // }
        }
    },
    type: {
        type: 'dropdown',
        label: 'Type of Chart',
        id: 'type',
        default: 'Column',
        helpText: 'Pick the type of chart you want to display.',
        fields: {
            text: 'text',
            value: 'value'
        },
        items: [
            { text: 'Line', value: 'Line' },
            { text: 'Column', value: 'Column' },
            { text: 'Bar', value: 'Bar' },
            { text: 'Count', value: 'Count' },
            { text: 'Pie', value: 'Pie' }
        ]
    },
    countBoxArrangement: {
        type: 'dropdown',
        label: 'Count Box Arrangement',
        id: 'countBoxArrangement',
        default: 'horizontal',
        helpText: 'How do you want the count boxes arranged?',
        logic: [
            {
                record: 'self',
                prop: 'display',
                valueType: 'criteria',
                criteria: 'this.valuesMap.type === "Count"'
            }
        ],
        fields: fieldsObj,
        items: [
            { text: 'Horizontal', value: 'horizontal' },
            { text: 'Vertical', value: 'vertical' },
        ]
    },
    chartTitle: {
        type: 'string',
        label: 'Chart Title',
        helpText: 'Title of the chart.',
        id: 'chartTitle',
        default: 'Chart Title'
    },
    hideChartTitle: {
        type: 'boolean',
        label: 'Hide Chart Title',
        helpText: 'Hides the chart title.',
        id: 'hideChartTitle',
        default: false
    },
    chartTitleStyleSettings: {
        type: 'OBJECT',
        label: 'Chart Title Settings',
        helpText: 'Settings such as text size and color, background color, border size and color, for the chart title.',
        default: {
            fontSize: '20px',
            color: '#000000ff',
            background: '#ffffffff',
            borderWidth: 0,
            borderStyle: 'none',
            borderColor: 'transparent',
            fontFamily: 'proxima-nova, sans-serif',
            fontStyle: 'normal',
            fontWeight: 'regular',
            textAlign: 'center'
        },
        properties: {
            fontSize: {
                type: 'dropdown',
                label: 'Chart Title Size',
                helpText: 'Set the size of the chart title.',
                default: '20px',
                fields: fieldsObj,
                items: mediumFontSizes.concat(largeFontSizes),
                id: 'fontSize'
            },
            textAlign: {
                type: 'dropdown',
                label: 'Text Alignment',
                id: 'textAlign',
                default: 'center',
                helpText: 'Text alignment for the chart title: left, right, center.',
                fields: fieldsObj,
                items: [
                    { text: 'Center', value: 'center' },
                    { text: 'Align Left', value: 'left' },
                    { text: 'Align Right', value: 'right' },
                ]
            },
            color: {
                type: 'color',
                label: 'Chart Title Color',
                id: 'color',
                helpText: 'Text color for the chart title.',
                default: '#000000ff',
                fields: fieldsObj,
                items: fontColors
            },
            background: {
                type: 'color',
                label: 'Chart Title Background Color',
                helpText: 'Background color for the chart title.',
                id: 'background',
                default: '#ffffffff',
                logic: [
                    {
                        record: 'self',
                        prop: 'display',
                        valueType: 'criteria',
                        criteria: 'this.valuesMap.type === "Count"'
                    }
                ],
            },
            fontFamily: {
                type: 'dropdown',
                label: 'Title Font',
                helpText: 'The font type used for the chart title.',
                default: 'proxima-nova, sans-serif',
                fields: fieldsObj,
                items: fontList,
                // itemTemplate: `<span><span :class="data.value"></span> {{data.text}}</span>`,
                id: 'fontFamily'
            },
            fontWeight: {
                type: 'dropdown',
                label: 'Font Weight',
                helpText: 'The font type used for the chart title.',
                default: '400',
                fields: fieldsObj,
                items: fontWeights,
                id: 'fontWeight'
            },
            fontStyle: {
                type: 'dropdown',
                label: 'Font Style',
                helpText: 'The font type used for the chart title.',
                default: 'normal',
                items: [
                    'normal',
                    'italic',
                ],
                id: 'fontStyle'
            },
        }
    },
    datapointStyles: {
        type: 'OBJECT',
        id: 'datapointStyles',
        label: 'Count Box Top Level Styles',
        helpText: 'Top Level styles apply to chart values that do not have lower level styling applied.',
        default: {
            countType: 'number',
            countTitle: 'Count Title',
            summaryKey: '',
            summaryValue: '',
            countBoxSpacing: '1',
            countBoxBorderSize: '1',
            countBoxBorderRadius: '1',
            countBoxBorderStyle: 'solid',
            countBoxBorderColor: '#000000ff',
            countBackgroundColor: '#08538a',
            countTextSize: '3',
            prefixUnit: '',
            postfixUnit: '',
            countTextPadding: '3',
            countTextColor: '#000000ff',
            countTitleTextSize: '2',
            countTitlePadding: '2',
            countTitleTextColor: '#222222ff',
            countTitleBackgroundColor: '#ddddddff'
        },
        logic: [
            {
                record: 'self',
                prop: 'display',
                valueType: 'criteria',
                criteria: 'this.valuesMap.type === "Count"'
            }
        ],
        properties: {
            countType: {
                type: 'dropdown',
                label: 'Number Format',
                id: 'countType',
                default: 'number',
                items: [
                    'number',
                    'percent',
                    'none'
                ],
                helpText: 'Format to use for the number value.'
            },
            tooltip: {
                id: 'tooltip',
                label: 'Tooltip Format',
                type: 'string',
                default: false,
                helpText: 'Format for the labelling of the tooltip. eg: {text} See more at: https://ej2.syncfusion.com/vue/documentation/api/accumulation-chart/accPoints/'
            },
            countNumberFormat: {
                id: 'countNumberFormat',
                label: 'Count Box Label Format',
                type: 'string',
                default: false,
                helpText: 'Format for the labelling of box values. eg: {value}'
            },
            countInfoArrangement: {
                type: 'dropdown',
                label: 'Count Info Arrangement',
                id: 'countInfoArrangement',
                default: 'vertical',
                helpText: 'How do you want the count number, title, and sub-title arranged?',
                fields: fieldsObj,
                items: [
                    { text: 'Horizontal', value: 'horizontal' },
                    { text: 'Vertical', value: 'vertical' },
                ]
            },
            countTextAlignment: {
                type: 'dropdown',
                label: 'Count Box Text Alignment',
                id: 'countTextAlignment',
                default: 'center',
                helpText: 'How do you want the count number value inside each count box aligned?',
                fields: fieldsObj,
                items: [
                    { text: 'Centered', value: 'center' },
                    { text: 'Left', value: 'left' },
                    { text: 'Right', value: 'right' },
                ]
            },
            countBoxSpacing: {
                type: 'dropdown',
                label: 'Count Box Spacing',
                id: 'countBoxSpacing',
                options: [
                    { text: 'none', value: '0', },
                    { text: '1px', value: '1', },
                    { text: '2px', value: '2', },
                    { text: '3px', value: '3', },
                    { text: '5px', value: '4', },
                    { text: '10px', value: '5' }
                ],
                fields: fieldsObj,
                default: '1',
                helpText: 'Text size for the count number ranging from 16px to 60px.'
            },
            countBoxBorderSize: {
                type: 'dropdown',
                label: 'Count Box Border Size',
                id: 'countBoxBorderSize',
                default: '1',
                options: [
                    { text: 'none', value: '0', },
                    { text: '1px', value: '1', },
                    { text: '2px', value: '2', },
                    { text: '3px', value: '3', },
                    { text: '4px', value: '4', },
                    { text: '5px', value: '5' }
                ],
                fields: fieldsObj,
                helpText: 'Border width for the count box ranging from 1px to 5px.'
            },
            countBoxBorderRadius: {
                type: 'dropdown',
                label: 'Count Box Border Radius',
                id: 'countBoxBorderRadius',
                default: '',
                options: [
                    { text: 'none', value: '1' },
                    { text: '3px', value: '2' },
                    { text: '5px', value: '3' },
                    { text: '10px', value: '4' }
                ],
                fields: fieldsObj,
                helpText: 'Border radius size for the count box.'
            },
            countBoxBorderStyle: {
                type: 'dropdown',
                label: 'Count Box Border Style',
                id: 'countBoxBorderStyle',
                options: [
                    'none',
                    'solid',
                    'dotted',
                    'dashed'
                ],
                default: 'solid',
                helpText: 'Set the border style for the count box.'
            },
            countBoxBorderColor: {
                type: 'color',
                label: 'Box Border Color',
                id: 'countBoxBorderColor',
                helpText: 'Set the border color for the count box.',
                default: '#000000ff'
            },
            countBackgroundColor: {
                type: 'color',
                label: 'Count Background Color',
                id: 'countBackgroundColor',
                helpText: 'Set the background color for the count box.',
                default: '#ffffffff'
            },
            countBoxHeight: {
                type: 'string',
                label: 'Count Box Height',
                id: 'countBoxHeight',
                helpText: 'Set a specific height for the count boxes'
            },
            countTextColor: {
                type: 'color',
                label: 'Count Text Color',
                id: 'countTextColor',
                helpText: 'Set the color for the count text.',
                default: ''
            },
            countTitleBackgroundColor: {
                type: 'color',
                label: 'Count Title Background Color',
                id: 'countTitleBackgroundColor',
                helpText: 'Set the color for the count title background',
                default: '#ddddddff'
            },
            countTitleTextColor: {
                type: 'color',
                label: 'Count Title Color',
                id: 'countTitleTextColor',
                helpText: 'Set the color for the count title text',
                default: '#222222ff'
            },
            countTextSize: {
                type: 'dropdown',
                label: 'Count Text Size',
                id: 'countTextSize',
                options: [
                    { text: '16px', value: '1', },
                    { text: '24px', value: '2', },
                    { text: '32px', value: '3', },
                    { text: '48px', value: '4', },
                    { text: '60px', value: '5' }
                ],
                fields: fieldsObj,
                default: '4',
                helpText: 'Text size for the count number ranging from 16px to 60px.'
            },
            countTextPadding: {
                type: 'string',
                label: 'Count Label Padding',
                id: 'countTextPadding',
                default: '3',
                helpText: 'Padding size for the count title ranging from 1px to 20px.'
            },
            countTitleTextSize: {
                type: 'dropdown',
                label: 'Count Title Text Size',
                id: 'countTitleTextSize',
                options: [
                    { text: '16px', value: '1', },
                    { text: '24px', value: '2', },
                    { text: '32px', value: '3', },
                    { text: '48px', value: '4', },
                    { text: '60px', value: '5' }
                ],
                fields: fieldsObj,
                helpText: 'Text size for the count title ranging from 16px to 60px.',
                default: '2'
            },
            countTitlePadding: {
                type: 'string',
                label: 'Count Title Text Padding',
                id: 'countTitlePadding',
                helpText: 'Padding size for the count title ranging from 1px to 20px.',
                default: '3'
            }
        }
    },
    primaryXAxis: {
        type: 'OBJECT',
        label: 'X Axis Settings',
        helpText: 'A chart has a label axis and a value axis.  The label axis settings control how the labels and bar positions are displayed.',
        default: {
            // labelStyle: { color: 'red', size: '40px' },
            valueType: 'Category',
            labelPlacement: 'BetweenTicks'
        },
        properties: {
            // palettes: ["#E94649", "#F6B53F", "#6FAAB0", "#C4C24A"],
            labelStyle: {
                type: 'OBJECT',
                label: 'Style Settings',
                helpText: 'Specify Primary Axis label settings such as font size, color, etc.',
                properties: {
                    color: {
                        type: 'dropdown',
                        label: 'Primary Axis Color',
                        helpText: 'The color of your interval labels',
                        default: '#635d5c',
                        fields: fieldsObj,
                        items: fontColors
                    },
                    fontFamily: {
                        type: 'dropdown',
                        label: 'Font',
                        helpText: 'The font family of your interval labels',
                        default: 'proxima-nova, sans-serif',
                        fields: fieldsObj,
                        items: fontList
                    },
                    fontWeight: {
                        type: 'dropdown',
                        label: 'Weight',
                        helpText: 'The font weight of your interval labels',
                        default: '600',
                        fields: fieldsObj,
                        items: fontWeights
                    },
                    size: {
                        type: 'dropdown',
                        label: 'Font Size',
                        helpText: 'Type in the size you want for the X Axis label.',
                        // message: 'eg: 16px',
                        default: '18px',
                        fields: fieldsObj,
                        items: smallFontSizes.concat(mediumFontSizes)
                    }
                },
                id: 'labelStyle'
            },
            valueType: {
                type: 'dropdown',
                label: 'Type of Data',
                helpText: 'Determines how the data will be grouped along the label axis.',
                default: 'Category',
                items: [
                    'Category'
                ],
                id: 'valueType'
            },
            labelPlacement: {
                type: 'dropdown',
                label: 'Label Placement',
                helpText: 'Position of Data Point Labels.',
                default: 'OnTicks',
                items: [
                    'OnTicks',
                    'BetweenTicks'
                ],
                id: 'labelPlacement'
            }
        }
    },
    primaryYAxis: {
        type: 'OBJECT',
        label: 'Y Axis Settings',
        helpText: 'The minimum and maximum values that will show as chart ticks along the value axis.',
        default: {
            minimum: 0
        },
        properties: {
            minimum: {
                type: 'number',
                label: 'Range Minimum',
                helpText: 'The minimum value that will display on the chart.',
                id: 'minimum'
            },
            maximum: {
                type: 'number',
                label: 'Range Maximum',
                helpText: 'The maximum value that will display on the chart.',
                id: 'maximum'
            },
            interval: {
                type: 'number',
                label: 'Tick Interval',
                helpText: 'How much each graph line, or tick, will represent.',
                default: 10,
                id: 'interval'
            },
            labelStyle: {
                type: 'OBJECT',
                label: 'Label Style Settings',
                helpText: 'Specify Secondary Axis label settings such as font size, color, etc.',
                properties: {
                    color: {
                        type: 'dropdown',
                        label: 'Label Color',
                        helpText: 'The color of your interval labels',
                        default: '#635d5c',
                        fields: fieldsObj,
                        items: fontColors
                    },
                    fontFamily: {
                        type: 'dropdown',
                        label: 'Font',
                        helpText: 'The font family of your interval labels',
                        default: 'proxima-nova, sans-serif',
                        fields: fieldsObj,
                        items: fontList
                    },
                    fontWeight: {
                        type: 'dropdown',
                        label: 'Weight',
                        helpText: 'The font weight of your interval labels',
                        default: '600',
                        fields: fieldsObj,
                        items: fontWeights
                    },
                    size: {
                        type: 'dropdown',
                        label: 'Font Size',
                        helpText: 'Type in the size you want for the X Axis label.',
                        // message: 'eg: 16px',
                        default: '14px',
                        fields: fieldsObj,
                        items: smallFontSizes.concat(mediumFontSizes)
                    }
                },
                id: 'labelStyle'
            },
            labelFormat: {
                id: 'labelFormat',
                label: 'Count Format',
                type: 'string',
                default: false,
                helpText: 'Format for the labelling of tick marks. eg: {value}'
            }
        }
    },
    legendSettings: {
        type: 'OBJECT',
        label: 'Chart Legend Settings',
        helpText: 'The settings that control the font size, color, etc.',
        default: {
            visible: true,
            legendShape: 'seriesType',
            textStyle: {
                fontFamily: 'Open Sans, sans-serif'
            }
        },
        properties: {
            width: {
                type: 'dropdown',
                label: 'Width',
                helpText: 'The width of your Legend',
                default: '200',
                fields: fieldsObj,
                items: [
                    { text: '100px', value: '100' },
                    { text: '150px', value: '150' },
                    { text: '200px', value: '200' },
                    { text: '250px', value: '250' },
                    { text: '300px', value: '300' },
                    { text: '400px', value: '400' },
                    { text: '500px', value: '500' },
                    { text: '600px', value: '600' },
                    { text: '700px', value: '700' },
                ]
            },
            visible: {
                type: 'boolean',
                label: 'Visibility',
                helpText: 'Turn the Legend ON or OFF',
                id: 'visible',
                default: true,
                items: [
                    true,
                    false
                ]
            },
            alignment: {
                type: 'dropdown',
                label: 'Alignment',
                helpText: 'The position of your Legend',
                default: 'Center',
                fields: fieldsObj,
                items: [
                    { text: 'Center', value: 'Center' },
                    { text: 'Align Right', value: 'Far' },
                    { text: 'Align Left', value: 'Near' },
                ]
            },
            position: {
                type: 'dropdown',
                label: 'Placement',
                helpText: 'The placement of your Legend in relation to the chart.',
                default: 'Bottom',
                items: [
                    'Auto',
                    'Top',
                    'Left',
                    'Bottom',
                    'Right'
                ]
            },
            padding: {
                type: 'dropdown',
                label: 'Legend Padding',
                helpText: 'The padding between multiple legends',
                default: 25,
                fields: fieldsObj,
                items: [
                    { text: 'Default', value: 25 },
                    { text: 'Closer', value: 15 },
                    { text: 'Farther Apart', value: 45 },
                ]
            },
            legendShape: {
                type: 'dropdown',
                label: 'Legend Shape',
                helpText: 'The shape representing the data',
                default: 'SeriesType',
                fields: fieldsObj,
                items: [
                    { text: 'SeriesType', value: 'SeriesType' },
                    { text: 'Square', value: 'Square' },
                    { text: 'Circle', value: 'Circle' },
                    { text: 'InvertedTriangle', value: 'InvertedTriangle' },
                    { text: 'Rectangle', value: 'Rectangle' },
                    { text: 'Diamond', value: 'Diamond' }
                ]
            },
            textStyle: {
                type: 'OBJECT',
                label: 'Legend Style Settings',
                helpText: 'Legend settings such as font size, color, etc.',
                properties: {
                    fontFamily: {
                        type: 'dropdown',
                        label: 'Legend Font',
                        helpText: 'The font family of your legend title',
                        default: 'proxima-nova',
                        fields: fieldsObj,
                        items: fontList
                    },
                    fontWeight: {
                        type: 'dropdown',
                        label: 'Legend Weight',
                        helpText: 'The font weight of your legend title',
                        default: '600',
                        fields: fieldsObj,
                        items: fontWeights
                    },
                    size: {
                        type: 'dropdown',
                        label: 'legend Font Size',
                        helpText: 'Type in the size you want for legend title',
                        // message: 'eg: 16px',
                        default: '12px',
                        fields: fieldsObj,
                        items: smallFontSizes
                    },
                    color: {
                        type: 'dropdown',
                        label: 'Text Color',
                        helpText: 'The color of your Legend Title',
                        default: '#08538a',
                        fields: fieldsObj,
                        items: fontColors
                    }
                },
                id: 'textStyle'
            },
        }
    },
    pieSettings: {
        type: 'OBJECT',
        label: 'Pie Chart Options',
        helpText: 'Settings to customize your Pie Chart.',
        logic: [
            {
                record: 'self',
                prop: 'display',
                valueType: 'criteria',
                criteria: 'this.valuesMap.type === "Pie"'
            }
        ],
        default: {
            innerRadius: '0',
            countType: 'number',
            dataLabel: {
                visible: true,
                name: 'pointLabel',
                position: 'Outside',
                font: {}
            },
            border: '0'
        },
        properties: {
            innerRadius: {
                type: 'dropdown',
                label: 'Inner Radius (Donut Chart)',
                helpText: 'Select an inner radius to create a Donut Chart',
                default: '0',
                items: [
                    '0',
                    '25%',
                    '40%',
                    '50%',
                    '80%',
                ]
            },
            countType: {
                type: 'dropdown',
                label: 'Number Format',
                id: 'countType',
                default: 'number',
                items: [
                    'number',
                    'percent',
                    'none'
                ],
                helpText: 'Format to use for the number value.'
            },
            dataLabel: {
                type: 'OBJECT',
                label: 'Data Label Options',
                helpText: 'Settings to customize your Pie Chart Labels.',
                properties: {
                    visible: {
                        type: 'boolean',
                        label: 'Visible/Hidden',
                        helpText: 'Show or Hide the Data Label for a Pie Chart',
                        items: [
                            true,
                            false
                        ]
                    },
                    name: {
                        type: 'dropdown',
                        label: 'Label as Text/Value',
                        helpText: 'Data as a Label or Value',
                        default: 'pointLabel',
                        fields: fieldsObj,
                        items: [
                            { text: 'Text Label', value: 'pointLabel' },
                            { text: 'Number Value', value: 'pointValue' },
                            { text: 'Label and Value', value: 'pointLabel pointValue' },
                            { text: 'Percent (10%)', value: 'p0' },
                            { text: 'Percent (10.0%)', value: 'p1' },
                            { text: 'Percent (10.00%)', value: 'p2' },
                            { text: 'Custom Format', value: 'customLabel' }
                        ]
                    },
                    customLabelFormat: {
                        type: 'text',
                        label: 'Custom Label Format',
                        id: 'customLabelFormat',
                        logic: [
                            {
                                record: 'self',
                                prop: 'display',
                                valueType: 'criteria',
                                criteria: 'this.valuesMap.pieSettings.dataLabel.name === "customLabel"'
                            }
                        ],
                        helpText: 'Label format for the pie.'
                    },
                    position: {
                        type: 'dropdown',
                        label: 'Inside or Outside',
                        helpText: 'Display Data Inside or Outside the Pie Chart',
                        items: [
                            'Outside',
                            'Inside'
                        ]
                    },
                    font: {
                        type: 'OBJECT',
                        label: 'Update Font and Size',
                        helpText: 'Settings to customize your Pie Chart Labels.',
                        properties: {
                            fontFamily: {
                                type: 'dropdown',
                                label: 'Data Label Font',
                                helpText: 'Font',
                                default: 'proxima-nova',
                                fields: fieldsObj,
                                items: fontList
                            },
                            fontWeight: {
                                type: 'dropdown',
                                label: 'Font Weight',
                                helpText: 'The font weight of your data',
                                default: '600',
                                fields: fieldsObj,
                                items: fontWeights
                            },
                            size: {
                                type: 'dropdown',
                                label: 'Font Size',
                                helpText: 'Font Size',
                                default: '16px',
                                fields: fieldsObj,
                                items: smallFontSizes.concat(mediumFontSizes)
                            },
                            color: {
                                type: 'dropdown',
                                label: 'Text Color',
                                helpText: 'The color of your Legend Title',
                                default: '#08538a',
                                fields: fieldsObj,
                                items: white.concat(fontColors)
                            }
                        }
                    }
                },
                default: {}
            },
            border: {
                type: 'OBJECT',
                label: 'Border Options',
                helpText: 'Add border "spacing" between data on Pie Chart.',
                properties: {
                    width: {
                        type: 'dropdown',
                        label: 'Border Width',
                        helpText: 'Spacing of the pie sections',
                        default: '0',
                        fields: fieldsObj,
                        items: [
                            { text: 'No Border', value: '0' },
                            { text: '2px', value: '2' },
                            { text: '5px', value: '5' },
                            { text: '10px', value: '10' }
                        ]
                    },
                    color: {
                        type: 'color',
                        label: 'Border Color',
                        helpText: 'Color of the space between sections',
                        default: 'pointLabel',
                        id: 'color',
                        fields: fieldsObj
                    },
                },
                default: {}
            }
        }
    },
    countSeries: {
        type: 'ARRAY',
        id: 'countSeries',
        label: 'Value Series',
        helpText: 'Each chart may have multiple series\' of data. Each series can be tied to a different dataset, or pull different summary data from the same dataset.',
        default: [],
        itemConfig: {
            primaryKey: 'seriesTitle',
            itemType: 'object',
            permissions: {
                canMove: true,
                canDelete: true,
                allowAddItem: true
            },
            keys: {
                hideSeriesTitle: {
                    type: 'boolean',
                    label: 'Hide Series Title',
                    id: 'hideSeriesTitle',
                    helpText: 'Hide the title that displays above the data series.',
                    default: false
                },
                seriesTitle: {
                    type: 'string',
                    label: 'Series Title',
                    id: 'seriesTitle',
                    helpText: 'The title displays with series.',
                    default: ''
                },
                datasetIds: {
                    id: 'datasetIds',
                    type: 'datasource',
                    itemsSource: 'configStore.getDatasourceList()',
                    fields: {
                        text: 'text',
                        value: 'value',
                        parentValue: 'pId',
                        hasChildren: 'hasChild'
                    },
                    label: "Data Sources for Values",
                    onchange: "selectDataset",
                    filterType: 'contains',
                    allowFiltering: true,
                    helpText: 'Use a dataset as a source of data for the chart values in this series.',
                    message: 'Data Sources provide data for this chart series.',
                    default: [],
                    secondaryActions: [{
                        text: 'Dataset Details',
                        action: 'viewDataset',
                        source: 'actionStore',
                        params: {}
                    }, {
                        text: 'New Dataset',
                        action: 'createDataset',
                        source: 'actionStore',
                        params: {}
                    }]
                },
                countList: {
                    type: 'ARRAY',
                    id: 'countList',
                    label: 'Chart Values',
                    helpText: 'Each chart value represents a summary of data with a label displayed in the specified chart format.',
                    default: [],
                    itemConfig: {
                        primaryKey: 'countTitle',
                        itemType: 'object',
                        permissions: {
                            canMove: true,
                            canDelete: true,
                            allowAddItem: true
                        },
                        keys: {
                            valueType: {
                                type: 'dropdown',
                                label: 'Value Type',
                                id: 'valueType',
                                items: [
                                    { text: 'Total Records', value: 'rowCount' },
                                    { text: 'Count of Field/Value Matches', value: 'columnSummary' },
                                    { text: 'Sum of Field/Value Match', value: 'colSum' },
                                    { text: 'Calculated Value', value: 'calcValue' },
                                    { text: 'Static Value', value: 'staticValue' },
                                ],
                                fields: {
                                    text: 'text',
                                    value: 'value',
                                },
                                helpText: 'Value type tells the chart how to extract the count from your dataset. ',
                                default: 'rowCount'
                            },
                            summaryKey: {
                                type: 'dropdowntree',
                                itemsSource: 'configStore.getDatasetColumnOptions(this.valuesMap.countSeries[__index__].datasetIds)',
                                // eslint-disable-next-line max-len
                                itemsFilter: '(this.valuesMap.countSeries[__index__].countList[__index__].valueType === "columnSummary" && (this.item.value.indexOf("::columnSummary") !== -1 || this.item.value.indexOf("::WITHOUT_VALUE") !== -1 || this.item.value.indexOf("::WITH_VALUE") !== -1)) || (this.component.valuesMap.countSeries[__index__].countList[__index__].valueType === "colSum" && this.item.value.indexOf("::COL_SUM") !== -1) || (this.component.valuesMap.countSeries[__index__].countList[__index__].valueType === "rowCount" && this.item.value.indexOf("::rowCount") !== -1) || this.component.valuesMap.countSeries[__index__].countList[__index__].valueType === "calcValue"',
                                label: 'Summary Key',
                                id: 'summaryKey',
                                allowFiltering: true,
                                allowMultiSelection: false,
                                expandOn: 'Click',
                                fields: {
                                    text: 'text',
                                    value: 'value',
                                    parentValue: 'pId',
                                    hasChildren: 'hasChild'
                                },
                                logic: [
                                    {
                                        record: 'self',
                                        prop: 'display',
                                        valueType: 'criteria',
                                        criteria: `this.valuesMap.countSeries[__index__].countList[__index__].valueType !== "staticValue"
                                            && this.valuesMap.countSeries[__index__].countList[__index__].valueType !== "calcValue"`
                                    }
                                ],
                                default: [],
                                helpText: 'Select the summary key you want to use for this data point.'
                            },
                            staticValue: {
                                type: 'string',
                                label: 'Static Value',
                                id: 'staticValue',
                                default: '',
                                logic: [
                                    {
                                        record: 'self',
                                        prop: 'display',
                                        valueType: 'criteria',
                                        criteria: 'this.valuesMap.countSeries[__index__].countList[__index__].valueType === "staticValue"'
                                    }
                                ],
                            },
                            calculatedValue: {
                                label: 'Calculated Value',
                                id: 'calculatedValue',
                                type: 'calccontrol',
                                itemsSource: 'configStore.getDatasetColumnOptions(this.component.valuesMap.countSeries[__index__].datasetIds)',
                                // itemsFilter: 'this.component.valuesMap.countSeries[__index__].datasetIds.indexOf(this.item.dsId) !== -1',
                                default: [],
                                logic: [
                                    {
                                        record: 'self',
                                        prop: 'display',
                                        valueType: 'criteria',
                                        criteria: 'this.valuesMap.countSeries[__index__].countList[__index__].valueType === "calcValue"'
                                    }
                                ],
                            },
                            summaryValue: {
                                type: 'string',
                                label: 'Summary Value',
                                id: 'summaryValue',
                                default: '',
                                helpText: 'The summary value will be used to determine which values are counted for this data point.',
                                logic: [
                                    {
                                        record: 'self',
                                        prop: 'display',
                                        valueType: 'criteria',
                                        // eslint-disable-next-line max-len
                                        criteria: 'this.valuesMap.countSeries[__index__].countList[__index__].valueType !== "rowCount" && this.valuesMap.countSeries[__index__].countList[__index__].valueType !== "staticValue" && this.valuesMap.countSeries[__index__].countList[__index__].valueFilter !== "yes"'
                                    }
                                ],
                            },
                            valueFilter: {
                                type: 'dropdown',
                                label: 'Apply Additional Filtering?',
                                id: 'valueFilter',
                                items: [
                                    { text: 'Yes', value: 'yes' },
                                    { text: 'No', value: 'no' },
                                ],
                                fields: {
                                    text: 'text',
                                    value: 'value',
                                },
                                helpText: 'Additional value filtering can be applied to the records before the values are accumulated.',
                                default: 'no'
                            },
                            logicValue: {
                                type: 'logicEditor',
                                label: 'Logic Comparison Value',
                                id: 'logicValue',
                                helpText: 'use the logic comparison value for more advanced data matching',
                                otherProps: {
                                    recordTypes: [
                                        { text: 'Row', value: 'object1' }
                                    ],
                                    itemsSource: 'configStore.getDatasetColumnOptions(this.component.valuesMap.countSeries[__index__].datasetIds)',
                                    // eslint-disable-next-line max-len
                                    itemsFilter: 'this.component.valuesMap.countSeries[__index__].countList[__index__].valueType === "columnSummary" && (this.item.value.indexOf("::columnSummary") !== -1 || this.item.value.indexOf("::WITHOUT_VALUE") !== -1 || this.item.value.indexOf("::WITH_VALUE") !== -1)) || (this.component.valuesMap.countSeries[__index__].countList[__index__].valueType === "colSum" && this.item.value.indexOf("::COL_SUM") !== -1) || (this.component.valuesMap.countSeries[__index__].countList[__index__].valueType === "rowCount" && this.item.value.indexOf("::rowCount") !== -1) || this.component.valuesMap.countSeries[__index__].countList[__index__].valueType === "calcValue"',
                                    defaultRecordType: 'object1',
                                    hideStandardRecordTypes: true
                                },
                                logic: [
                                    {
                                        record: 'self',
                                        prop: 'display',
                                        valueType: 'criteria',
                                        criteria: 'this.valuesMap.countSeries[__index__].countList[__index__].valueFilter === "yes"'
                                    }
                                ]
                            },
                            logicDataset: {
                                label: 'Grid to use for logic',
                                type: 'dropdown',
                                allowFiltering: true,
                                filterType: 'contains',
                                itemsSource: 'configStore.getDatasetList()',
                                fields: { text: 'cTitle', value: 'dsId' },
                                id: 'logicDataset',
                                logic: [
                                    {
                                        record: 'self',
                                        prop: 'display',
                                        valueType: 'criteria',
                                        criteria: 'this.valuesMap.countSeries[__index__].countList[__index__].valueFilter === "yes"'
                                    }
                                ],
                            },
                            countTitle: {
                                type: 'string',
                                label: 'Data Point Title',
                                id: 'countTitle',
                                helpText: 'The data point title displays with the count.',
                                default: 'Point Title'
                            },
                            countSubTitle: {
                                type: 'string',
                                label: 'Data Point Sub-Title',
                                id: 'countSubTitle',
                                helpText: 'Display additional information below the count title.',
                                default: ''
                            },
                            countItemTextAlignment: {
                                type: 'dropdown',
                                label: 'Count Text Alignment',
                                id: 'countItemTextAlignment',
                                default: 'center',
                                helpText: 'How do you want the text inside this count box aligned?',
                                fields: fieldsObj,
                                items: [
                                    { text: 'Centered', value: 'center' },
                                    { text: 'Left', value: 'left' },
                                    { text: 'Right', value: 'right' },
                                ]
                            },
                            countItemImageSettings: {
                                type: 'object',
                                label: 'Count Item Image',
                                id: 'countItemImageSettings',
                                helpText: 'Include an image with your countbox type data point.',
                                properties: {
                                    imageFile: {
                                        type: 'upload',
                                        label: 'Count Item Image',
                                        id: 'imageFile',
                                        psp: 'component',
                                        helpText: 'Upload an image to go with this count item.'
                                    },
                                    imagePosition: {
                                        type: 'dropdown',
                                        label: 'Count Item Image Position',
                                        items: [
                                            { text: 'Above', value: 'above' },
                                            { text: 'Below', value: 'below' },
                                            { text: 'Left', value: 'left' },
                                            { text: 'Right', value: 'right' },
                                            { text: 'Background', value: 'background' },
                                        ],
                                        fields: {
                                            text: 'text',
                                            value: 'value'
                                        },
                                        id: 'imagePosition',
                                        helpText: 'Position of image relative to the count text.'
                                    },
                                    height: {
                                        type: 'string',
                                        label: 'height',
                                        id: 'height',
                                        helpText: 'https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit',
                                        logic: [
                                            {
                                                record: 'self',
                                                prop: 'display',
                                                valueType: 'criteria',
                                                criteria: 'this.valuesMap.countSeries[__index__].countList[__index__]?.countItemImageSettings?.imagePosition !== "background"'
                                            }
                                        ]
                                    },
                                    width: {
                                        type: 'string',
                                        label: 'width',
                                        id: 'width',
                                        helpText: 'width of the image in px, %, em, or vh/vw',
                                        logic: [
                                            {
                                                record: 'self',
                                                prop: 'display',
                                                valueType: 'criteria',
                                                criteria: 'this.valuesMap.countSeries[__index__].countList[__index__]?.countItemImageSettings?.imagePosition !== "background"'
                                            }
                                        ]
                                    },
                                    objectFit: {
                                        type: 'string',
                                        label: 'Object Fit',
                                        id: 'objectFit',
                                        helpText: 'https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit',
                                        logic: [
                                            {
                                                record: 'self',
                                                prop: 'display',
                                                valueType: 'criteria',
                                                criteria: 'this.valuesMap.countSeries[__index__].countList[__index__]?.countItemImageSettings?.imagePosition !== "background"'
                                            }
                                        ]
                                    },
                                    objectPosition: {
                                        type: 'string',
                                        label: 'Object Position',
                                        id: 'objectPosition',
                                        helpText: 'https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit',
                                        logic: [
                                            {
                                                record: 'self',
                                                prop: 'display',
                                                valueType: 'criteria',
                                                criteria: 'this.valuesMap.countSeries[__index__].countList[__index__]?.countItemImageSettings?.imagePosition !== "background"'
                                            }
                                        ]
                                    },
                                    backgroundSize: {
                                        type: 'string',
                                        label: 'Background Size',
                                        id: 'backgroundSize',
                                        helpText: 'https://developer.mozilla.org/en-US/docs/Web/CSS/background-size',
                                        logic: [
                                            {
                                                record: 'self',
                                                prop: 'display',
                                                valueType: 'criteria',
                                                criteria: 'this.valuesMap.countSeries[__index__].countList[__index__]?.countItemImageSettings?.imagePosition === "background"'
                                            }
                                        ]
                                    },
                                    backgroundPosition: {
                                        type: 'string',
                                        label: 'Background Position',
                                        id: 'backgroundPosition',
                                        helpText: 'https://developer.mozilla.org/en-US/docs/Web/CSS/background-position',
                                        logic: [
                                            {
                                                record: 'self',
                                                prop: 'display',
                                                valueType: 'criteria',
                                                criteria: 'this.valuesMap.countSeries[__index__].countList[__index__]?.countItemImageSettings?.imagePosition === "background"'
                                            }
                                        ]
                                    }
                                }
                            },
                            countSubActionText: {
                                type: 'string',
                                label: 'Sub Action Text',
                                id: 'countSubActionText',
                                helpText: 'Display clickable text below the count box'
                            },
                            prefixUnit: {
                                type: 'string',
                                label: 'Prefix Unit',
                                id: 'prefixUnit',
                                placeholder: 'eg: $, #',
                                default: '',
                                logic: [
                                    {
                                        record: 'self',
                                        prop: 'display',
                                        valueType: 'criteria',
                                        criteria: 'this.valuesMap.type === "Count"'
                                    }
                                ],
                                helpText: 'Specify a unit of measurement to be displayed before the number.'
                            },
                            postfixUnit: {
                                type: 'string',
                                label: 'Postfix Unit',
                                id: 'postfixUnit',
                                placeholder: 'eg: %, ft, miles',
                                allowCustomValue: true,
                                fields: fieldsObj,
                                default: '',
                                logic: [
                                    {
                                        record: 'self',
                                        prop: 'display',
                                        valueType: 'criteria',
                                        criteria: 'this.valuesMap.type === "Count"'
                                    }
                                ],
                                helpText: 'Specify a unit of measurement to be displayed after the number.'
                            },
                            clickAction: {
                                label: 'Click Action',
                                id: 'clickAction',
                                type: 'actionfield',
                                itemsSource: 'actionStore.getActionOptions()',
                                fields: { text: 'text', value: 'value' },
                                helpText: 'Choose from a list of standard actions that you want to execute when a user clicks the data point.',
                                default: {
                                    action: '',
                                    params: {}
                                }
                            },
                            displayWhenCondensed: {
                                type: 'boolean',
                                label: 'Display When Condensed',
                                id: 'displayWhenCondensed',
                                default: false,
                                helpText: 'Charts can be condensed and displayed inline with other text. This data point will be displayed when a chart is condensed.'
                            },
                            countBoxSpacing: {
                                type: 'dropdown',
                                label: 'Count Box Spacing',
                                id: 'countBoxSpacing',
                                options: [
                                    { text: 'none', value: '0', },
                                    { text: '1px', value: '1', },
                                    { text: '2px', value: '2', },
                                    { text: '3px', value: '3', },
                                    { text: '5px', value: '4', },
                                    { text: '10px', value: '5' }
                                ],
                                fields: {
                                    text: 'text',
                                    value: 'value'
                                },
                                logic: [
                                    {
                                        record: 'self',
                                        prop: 'display',
                                        valueType: 'criteria',
                                        criteria: 'this.valuesMap.type === "Count"'
                                    }
                                ],
                                default: '',
                                helpText: 'Text size for the count number ranging from 16px to 60px.'
                            },
                            countBoxBorderSize: {
                                type: 'dropdown',
                                label: 'Count Box Border Size',
                                id: 'countBoxBorderSize',
                                default: '',
                                options: [
                                    { text: '1px', value: '1', },
                                    { text: '2px', value: '2', },
                                    { text: '3px', value: '3', },
                                    { text: '4px', value: '4', },
                                    { text: '5px', value: '5' }
                                ],
                                fields: {
                                    text: 'text',
                                    value: 'value'
                                },
                                logic: [
                                    {
                                        record: 'self',
                                        prop: 'display',
                                        valueType: 'criteria',
                                        criteria: 'this.valuesMap.type === "Count"'
                                    }
                                ],
                                helpText: 'Border width for the count box ranging from 1px to 5px.'
                            },
                            countBoxBorderRadius: {
                                type: 'dropdown',
                                label: 'Count Box Border Radius',
                                id: 'countBoxBorderRadius',
                                default: '',
                                options: [
                                    { text: 'none', value: '1' },
                                    { text: '3px', value: '2' },
                                    { text: '5px', value: '3' },
                                    { text: '10px', value: '4' }
                                ],
                                fields: {
                                    text: 'text',
                                    value: 'value'
                                },
                                logic: [
                                    {
                                        record: 'self',
                                        prop: 'display',
                                        valueType: 'criteria',
                                        criteria: 'this.valuesMap.type === "Count"'
                                    }
                                ],
                                helpText: 'Border radius size for the count box.'
                            },
                            countBoxBorderStyle: {
                                type: 'dropdown',
                                label: 'Count Box Border Style',
                                id: 'countBoxBorderStyle',
                                options: [
                                    'none',
                                    'solid',
                                    'dotted',
                                    'dashed'
                                ],
                                default: '',
                                logic: [
                                    {
                                        record: 'self',
                                        prop: 'display',
                                        valueType: 'criteria',
                                        criteria: 'this.valuesMap.type === "Count"'
                                    }
                                ],
                                helpText: 'Set the border style for the count box.'
                            },
                            countBoxBorderColor: {
                                type: 'color',
                                label: 'Box Border Color',
                                id: 'countBoxBorderColor',
                                logic: [
                                    {
                                        record: 'self',
                                        prop: 'display',
                                        valueType: 'criteria',
                                        criteria: 'this.valuesMap.type === "Count"'
                                    }
                                ],
                                helpText: 'Set the border color for the count box.',
                                default: ''
                            },
                            countBackgroundColor: {
                                type: 'color',
                                label: 'Count Background Color',
                                id: 'countBackgroundColor',
                                logic: [
                                    {
                                        record: 'self',
                                        prop: 'label',
                                        valueType: 'value',
                                        value: 'Data Point Color',
                                        criteria: 'this.valuesMap.type !== "Count"'
                                    }, {
                                        record: 'self',
                                        prop: 'disabled',
                                        valueType: 'criteria',
                                        criteria: 'this.valuesMap.useDefaultColors.value'
                                    }, {
                                        record: 'self',
                                        prop: 'message',
                                        valueType: 'value',
                                        value: 'This setting is disabled because "Use Default Colors" is selected in "Basic Settings"',
                                        criteria: 'this.valuesMap.useDefaultColors.value'
                                    }
                                ],
                                helpText: 'Set the background color for the count box.',
                                default: ''
                            },
                            countTextColor: {
                                type: 'color',
                                label: 'Count Text Color',
                                id: 'countTextColor',
                                helpText: 'Set the color for the count text.',
                                logic: [
                                    {
                                        record: 'self',
                                        prop: 'display',
                                        valueType: 'criteria',
                                        criteria: 'this.valuesMap.type === "Count"'
                                    }
                                ],
                                default: ''
                            },
                            countTitleBackgroundColor: {
                                type: 'color',
                                label: 'Count Title Background Color',
                                id: 'countTitleBackgroundColor',
                                helpText: 'Set the color for the count title background',
                                logic: [
                                    {
                                        record: 'self',
                                        prop: 'display',
                                        valueType: 'criteria',
                                        criteria: 'this.valuesMap.type === "Count"'
                                    }
                                ],
                                default: ''
                            },
                            countTitleTextColor: {
                                type: 'color',
                                label: 'Count Title Color',
                                id: 'countTitleTextColor',
                                helpText: 'Set the color for the count title text',
                                logic: [
                                    {
                                        record: 'self',
                                        prop: 'display',
                                        valueType: 'criteria',
                                        criteria: 'this.valuesMap.type === "Count"'
                                    }
                                ],
                                default: ''
                            },
                            countTextSize: {
                                type: 'dropdown',
                                label: 'Count Text Size',
                                id: 'countTextSize',
                                options: [
                                    { text: '16px', value: '1', },
                                    { text: '24px', value: '2', },
                                    { text: '32px', value: '3', },
                                    { text: '48px', value: '4', },
                                    { text: '60px', value: '5' }
                                ],
                                fields: fieldsObj,
                                logic: [
                                    {
                                        record: 'self',
                                        prop: 'display',
                                        valueType: 'criteria',
                                        criteria: 'this.valuesMap.type === "Count"'
                                    }
                                ],
                                default: '',
                                helpText: 'Text size for the count number ranging from 16px to 60px.'
                            },
                            countTextPadding: {
                                type: 'string',
                                label: 'Count Label Padding',
                                id: 'countTextPadding',
                                logic: [
                                    {
                                        record: 'self',
                                        prop: 'display',
                                        valueType: 'criteria',
                                        criteria: 'this.valuesMap.type === "Count"'
                                    }
                                ],
                                default: '',
                                helpText: 'Padding size for the count number/value as css padding string (top right bottom left). eg: 10px 10px 10px 10px'
                            },
                            countTitleTextSize: {
                                type: 'dropdown',
                                label: 'Count Title Text Size',
                                id: 'countTitleTextSize',
                                options: [
                                    { text: '16px', value: '1', },
                                    { text: '24px', value: '2', },
                                    { text: '32px', value: '3', },
                                    { text: '48px', value: '4', },
                                    { text: '60px', value: '5' }
                                ],
                                fields: fieldsObj,
                                logic: [
                                    {
                                        record: 'self',
                                        prop: 'display',
                                        valueType: 'criteria',
                                        criteria: 'this.valuesMap.type === "Count"'
                                    }
                                ],
                                helpText: 'Text size for the count title ranging from 16px to 60px.',
                                default: ''
                            },
                            countTitlePadding: {
                                type: 'string',
                                label: 'Count Title Text Padding',
                                id: 'countTitlePadding',
                                logic: [
                                    {
                                        record: 'self',
                                        prop: 'display',
                                        valueType: 'criteria',
                                        criteria: 'this.valuesMap.type === "Count"'
                                    }
                                ],
                                helpText: 'Padding size for the count title as css padding string (top right bottom left). eg: 10px 10px 10px 10px',
                                default: ''
                            },
                            labelFormat: {
                                type: 'string',
                                label: 'Count Format',
                                id: 'labelFormat',
                                placeholder: 'eg: {value}',
                                default: '',
                                logic: [
                                    {
                                        record: 'self',
                                        prop: 'display',
                                        valueType: 'criteria',
                                        criteria: 'this.valuesMap.type === "Count"'
                                    }
                                ],
                                helpText: 'Specify the format of the count.'
                            },
                        },
                        newItem: {
                            countTitle: 'Count Title',
                            summaryKey: '',
                            summaryValue: '',
                            staticValue: '',
                            countBoxSpacing: '',
                            countBoxBorderSize: '',
                            countBoxBorderStyle: '',
                            countBoxBorderColor: '',
                            countBackgroundColor: '',
                            clickAction: [],
                            countTextSize: '',
                            prefixUnit: '',
                            postfixUnit: '',
                            countTextPadding: '',
                            countTextColor: '',
                            countTitleTextSize: '',
                            countTitlePadding: '',
                            countTitleTextColor: '',
                            countTitleBackgroundColor: '',
                            countItemImageSettings: {}
                        }
                    }
                }
            },
            newItem: {
                seriesTitle: 'Series Title',
                hideSeriesTitle: false,
                datasetIds: [],
                countList: []
            }
        }
    },
    chartWidth: {
        type: 'string',
        id: 'chartWidth',
        label: 'Chart Width',
        helpText: 'Overall width of the chart in common css units.',
        message: 'eg: 100% or 200px',
        default: '100%'
    },
    chartHeight: {
        type: 'string',
        id: 'chartHeight',
        label: 'Chart Height',
        helpText: 'Overall height of the chart in pixels or em space.',
        message: 'eg: 200px',
        default: '200px'
    },
    useDefaultColors: {
        type: 'boolean',
        id: 'useDefaultColors',
        label: 'Use Default Data Point Colors',
        helpText: 'Allow the chart data point colors to be set automatically.',
        default: true
    }
};

const chartCmp = {
    name: 'chart',
    editorSettings: editorSettings,
    props: {
        seriesData: {
            default: false
        },
        ignoreDataset: {
            default: false
        },
        condenseChart: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            datasetsLoaded: false,
            displaySeriesDataLoaded: false,
            condensedDisplayData: [],
            marker: {
                visible: true, width: 6, height: 6
            }
        };
    },
    computed: {
        datasetData() {
            let subscriptionKeys = [];
            // Get Request Types for addParams config
            let requestTypes = this.getRequestTypes();
            // Collect Unique Dataset Ids
            let datasets = [];
            if (Array.isArray(this.config.countSeries)) {
                this.config.countSeries.forEach((series) => {
                    datasets = datasets.concat(series.datasetIds);
                });
            }
            datasets = [...new Set(datasets)];
            datasets.forEach((datasetId) => {
                datasetId = typeof datasetId === "object" ? datasetId.source[0] : datasetId;
                let addParams = {
                    useCaCode: 1,
                    rowCount: 1,
                    // colValSummary: "all"
                };
                if (requestTypes.summary[datasetId] || requestTypes.lbeSum[datasetId]) addParams.colValSummary = "all";
                if (requestTypes.sum[datasetId] || requestTypes.logic[datasetId]) addParams.rowCount = 100000;
                let currDataset = this.configStore && Array.isArray(this.configStore.datasetList) ? this.configStore.datasetList.find((dataset) => dataset.dsId === datasetId) : false;
                if (currDataset) {
                    let subscription = this.recordStore.subscribe({
                        source: currDataset.dsId,
                        psp: currDataset.pspID,
                        isLogbook: currDataset.isLogBook,
                        addParams,
                        updateFrequency: 0
                    });
                    subscriptionKeys.push(subscription.key);
                } else {
                    this.errorHandler.log('Missing Dataset: ' + datasetId);
                }
            });
            return {
                datasets,
                subscriptionKeys,
                requestTypes
            };
        },
        displaySeriesData() {
            // if seriesData was passed through the props
            if (this.seriesData) {
                // Format for chart display (count display does not use this)
                return this.formatChartData(this.seriesData);
            }
            if (!this.datasetsLoaded) return {};
            // Gather series dataset
            if (!Array.isArray(this.config.countSeries) || !this.config.countSeries.length) return {};
            library.showLoadingIndicator(this.cId);
            let { requestTypes, subscriptionKeys, datasets } = this.datasetData;
            let seriesData = {};
            subscriptionKeys.forEach((subKey, index) => {
                let subscriptionRecords = this.recordStore.getSubscription(subKey);
                let subscriptionInfo = this.recordStore.records.subscription[subKey];
                // Set a default amount
                let dsSource = typeof datasets[index] === 'object' ? datasets[index].source[0] : datasets[index];
                let rowCountKey = dsSource + '::rowCount';
                if (!seriesData[rowCountKey]) seriesData[rowCountKey] = 0;
                // Process Responses
                if (Object.keys(subscriptionRecords).length === 0) return;
                if (subscriptionInfo.rowCount) seriesData[rowCountKey] = subscriptionInfo.rowCount;
                if (subscriptionInfo['summary']) {
                    let summaryKeys = Object.keys(subscriptionInfo['summary']);
                    summaryKeys.forEach((sKey) => {
                        let thisSummaryKey;
                        if (requestTypes.lbeSum[dsSource]) {
                            thisSummaryKey = dsSource + '::' + sKey + '::COL_SUM';
                        } else {
                            thisSummaryKey = dsSource + '::' + sKey + '::columnSummary';
                        }
                        let resValue = subscriptionInfo['summary'][sKey];
                        // Check for LBE Sum values
                        if (Array.isArray(resValue)) {
                            resValue = resValue[0];
                        }
                        if (typeof resValue === 'string') resValue = Number(resValue.replace(/\D/g, ''));
                        seriesData[thisSummaryKey] = resValue;
                    });
                }
                if (requestTypes.sum[dsSource]) {
                    let sumKeys = Object.keys(requestTypes.sum[dsSource]);
                    sumKeys.forEach((sKey) => {
                        let thisSumKey = dsSource + '::' + sKey + '::COL_SUM';
                        let sumValue = 0;
                        subscriptionRecords.forEach((dItem) => {
                            let val = Number(dItem[sKey]);
                            if (!isNaN(val)) sumValue += val;
                        });
                        seriesData[thisSumKey] = sumValue;
                    });
                }
                if (requestTypes.logic[dsSource]) {
                    let logicKey = dsSource + '::logic';
                    seriesData[logicKey] = subscriptionRecords;
                }
            });
            // Map to component State data
            // Format for chart display (count display does not use this)
            library.hideLoadingIndicator(this.cId);
            return this.formatChartData(seriesData);
        },
        pieDataLabel() {
            let dlSettings = this.config?.pieSettings?.dataLabel;
            if (!dlSettings) return false;
            let percentValues = ['p0', 'p1', 'p2'];
            let template;
            if (dlSettings.name === 'customLabel' && dlSettings.customLabelFormat) {
                template = dlSettings.customLabelFormat;
                template = template.replace(/{(text|label)}/g, '{point.x}').replace(/{value}/g, '{point.y}');
            }
            else if (percentValues.indexOf(dlSettings.name) > -1) {
                let decimals = Number(dlSettings.name.replace('p', ''));
                template = '{(point.y * 100).toFixed(' + decimals + ')}%';
            }
            else { //  dlSettings.name === pointLabel or pointValue
                template = dlSettings.name;
                let valString = this.dataFormat === 'percent' ? '{(point.y * 100).toFixed(' + 0 + ')}%' : '{point.y}';
                template = template.replace('pointLabel', '{point.x}').replace('pointValue', valString);
            }
            let fullTemplate;
            // Font settings
            if (!dlSettings.font) dlSettings.font = {};
            let defaults = {
                color: 'black',
                fontFamily: 'Open Sans',
                fontWeight: 'normal',
                size: '16px',
            };
            dlSettings.font = { ...defaults, ...dlSettings.font };
            fullTemplate = `<div style="color: ${dlSettings.font.color};
                font-family: ${dlSettings.font.fontFamily};
                font-weight: ${dlSettings.font.fontWeight};
                font-size: ${dlSettings.font.size};">${template}
            </div>`;
            // Clean up the template
            if (fullTemplate) {
                fullTemplate = fullTemplate.replace(/{/g, '${');
                fullTemplate = fullTemplate.replace(/\$\${/g, '${');
            }
            return {
                visible: dlSettings.visible,
                position: dlSettings.position,
                template: fullTemplate
            };
        },
        dataFormat() {
            if (this.config.type === 'Pie') return this.config.pieSettings.countType;
            return this.config.datapointStyles && this.config.datapointStyles.countType;
        },
        tooltip() {
            let output = { enable: true };
            if (this.config.type === 'Pie') {
                let dlSettings = this.config.pieSettings && this.config.pieSettings.dataLabel;
                let percentValues = ['p0', 'p1', 'p2'];
                let tooltipText;
                if (library.getByPath(this, 'this.config.datapointStyles.tooltip')) {
                    tooltipText = library.getByPath(this, 'this.config.datapointStyles.tooltip');
                }
                else if (dlSettings.name === 'customLabel' && dlSettings.customLabelFormat) {
                    tooltipText = dlSettings.customLabelFormat;
                    tooltipText = tooltipText.replace(/{(text|label)}/g, '{x}').replace(/{value}/g, '{y}');
                }
                else if (percentValues.indexOf(dlSettings.name) > -1) {
                    let decimals = Number(dlSettings.name.replace('p', ''));
                    tooltipText = '{x}: {(y * 100).toFixed(' + decimals + ')}%';
                }
                else if (this.dataFormat === 'percent') {
                    // Percent type values with no label format selected
                    let decimals = 0;
                    tooltipText = '{x}: {(y * 100).toFixed(' + decimals + ')}%';
                }
                else tooltipText = '<b>{x}: {y}</b>';
                tooltipText = tooltipText.replace(/{/g, '${');
                output.template = tooltipText;
            }
            else if (this.config.datapointStyles.tooltip) {
                output.template = this.config.datapointStyles.tooltip;
            }
            return output;
        },
        formattedDisplaySeriesData() {
            let dataFormat = this.dataFormat;
            if (!dataFormat) return this.displaySeriesData;
            let formattedData = {};
            for (let seriesKey in this.displaySeriesData) {
                if (seriesKey === 'length') continue;
                formattedData[seriesKey] = [];
                let series = this.displaySeriesData[seriesKey];
                if (!Array.isArray(series)) continue;
                for (let dataKey in series) {
                    if (dataKey === 'length') continue;
                    formattedData[seriesKey][dataKey] = series[dataKey];
                    let pointValue = formattedData[seriesKey][dataKey].pointValue;
                    let valueFormat = formattedData[seriesKey][dataKey].labelFormat
                        || (this.config.datapointStyles && this.config.datapointStyles.countNumberFormat);
                    if (isNaN(pointValue)) {
                        pointValue = '---';
                    } else {
                        if (dataFormat === 'number') {
                            pointValue = Number(pointValue).toLocaleString('en');
                        }
                        if (valueFormat) {
                            pointValue = valueFormat.replace('{value}', pointValue);
                        }
                    }
                    formattedData[seriesKey][dataKey].pointValue = pointValue;
                }
            }
            return formattedData;
        },
        colorPalette() {
            let output = ['#444e86', '#955196', '#dd5182', '#ff6e54', '#ffa600'];
            let selectedPaletteOption = threeColorPalettes.find((palette) => palette.value === this.config.colorPalette);
            if (selectedPaletteOption) output = selectedPaletteOption.palette;
            return output;
        },
        piePalette() {
            let output = ['#444e86', '#955196', '#dd5182', '#ff6e54', '#ffa600'];
            let selectedPalette = fiveColorPalettes.find((palette) => palette.value === this.config.piePalette);
            if (selectedPalette) output = selectedPalette.palette;
            return output;
        },
        hasDisplayData() {
            return Object.keys(this.displaySeriesData).length;
        },
        chartRenderType() {
            let types = {
                Count: 'count',
                Line: 'chart',
                Column: 'chart',
                Bar: 'chart',
                Pie: 'accumulation',
                Donut: 'accumulation'
            };
            return types[this.config.type];
        },
        chartTitleStyles() {
            let output = this.config.chartTitleStyleSettings;
            let adjustAlignPropCase = () => {
                let alignKeys = {
                    left: 'Near',
                    center: 'Center',
                    right: 'Far',
                };
                output.textAlignment = alignKeys[output.textAlign];
            };
            if (output) {
                output.size = output.fontSize;
                adjustAlignPropCase();
            }
            return output;
        },
        chartBackground() {
            return this.chartArea && this.chartArea.chartBackground;
        },
        countBoxStyles() {
            let output = [];
            let setCountItemStyle = (countItem) => {
                let genStyles = this.config.datapointStyles;
                if (!genStyles) {
                    let componentsConfig = componentStore.get('componentsConfig');
                    if (componentsConfig[this.config.cType]
                        && componentsConfig[this.config.cType].editorSettings
                        && componentsConfig[this.config.cType].editorSettings.datapointStyles
                        && componentsConfig[this.config.cType].editorSettings.datapointStyles.default) {
                        genStyles = componentsConfig[this.config.cType].editorSettings.datapointStyles.default;
                    }
                }
                let conversions = {
                    borderSize: {
                        '0': '0',
                        '1': '1px',
                        '2': '2px',
                        '3': '3px',
                        '4': '5px',
                        '5': '10px',
                    },
                    margin: {
                        '0': '0',
                        '1': '1px',
                        '2': '2px',
                        '3': '3px',
                        '4': '5px',
                        '5': '10px'
                    },
                    textSize: {
                        '1': '16px',
                        '2': '24px',
                        '3': '32px',
                        '4': '48px',
                        '5': '60px'
                    },
                    padding: {
                        '1': '1px',
                        '2': '5px',
                        '3': '10px',
                        '4': '15px',
                        '5': '20px'
                    },
                    radius: {
                        '1': '0',
                        '2': '3px',
                        '3': '5px',
                        '4': '10px',
                    }
                };
                let countBoxHeight = genStyles.countBoxHeight;
                let countBackgroundColor = countItem.countBackgroundColor || genStyles.countBackgroundColor;
                let countBoxBorderColor = countItem.countBoxBorderColor || genStyles.countBoxBorderColor;
                let countBoxBorderSize = conversions.borderSize[countItem.countBoxBorderSize || genStyles.countBoxBorderSize];
                let countBoxBorderRadius = conversions.radius[countItem.countBoxBorderRadius || genStyles.countBoxBorderRadius];
                let countBoxBorderStyle = countItem.countBoxBorderStyle || genStyles.countBoxBorderStyle;
                let countBoxSpacing = conversions.margin[countItem.countBoxSpacing || genStyles.countBoxSpacing];
                let countTextColor = countItem.countTextColor || genStyles.countTextColor;
                let countTextPadding = conversions.padding[countItem.countTextPadding || genStyles.countTextPadding] || countItem.countTextPadding || genStyles.countTextPadding;
                let countTextSize = conversions.textSize[countItem.countTextSize || genStyles.countTextSize];
                let countTextAlignment = countItem.countItemTextAlignment;
                let countTitleBackgroundColor = countItem.countTitleBackgroundColor || genStyles.countTitleBackgroundColor;
                let countTitlePadding = conversions.padding[countItem.countTitlePadding || genStyles.countTitlePadding] || countItem.countTitlePadding || genStyles.countTitlePadding;
                let countTitleTextColor = countItem.countTitleTextColor || genStyles.countTitleTextColor;
                let countTitleTextSize = conversions.textSize[countItem.countTitleTextSize || genStyles.countTitleTextSize];
                let output = {
                    box: {
                        margin: countBoxSpacing,
                        backgroundColor: countBackgroundColor,
                        borderColor: countBoxBorderColor,
                        borderWidth: countBoxBorderSize,
                        borderStyle: countBoxBorderStyle,
                        borderRadius: countBoxBorderRadius,
                        textAlign: countTextAlignment
                    },
                    number: {
                        color: countTextColor,
                        padding: countTextPadding,
                        fontSize: countTextSize,
                    },
                    title: {
                        backgroundColor: countTitleBackgroundColor,
                        color: countTitleTextColor,
                        padding: countTitlePadding,
                        fontSize: countTitleTextSize,
                        justifyContent: countTextAlignment
                    },
                    image: {},
                    imageContainer: {},
                    action: {
                        margin: countBoxSpacing,
                    }
                };
                output.boxClasses = this.config.datapointStyles && this.config.datapointStyles.countInfoArrangement === 'horizontal' ? 'horizontal-count-info' : '';
                // Count Box Image Settings
                let imgSettings = countItem.countItemImageSettings;
                if (imgSettings) {
                    let imgFile = imgSettings.imageFile;
                    let bgImage = imgSettings.imagePosition === 'background' && imgFile;
                    let bgProps = bgImage && ['backgroundPosition', 'backgroundSize'];
                    let imgProps = imgFile && !bgImage && ['objectFit', 'objectPosition', 'height', 'width', 'maxHeight'];
                    let iProps = Object.keys(imgSettings);
                    iProps.forEach((prop) => {
                        if (bgProps && bgProps.indexOf(prop) !== -1) {
                            output.box[prop] = imgSettings[prop];
                        }
                        if (imgProps && imgProps.indexOf(prop) !== -1) {
                            output.image[prop] = imgSettings[prop];
                        }
                    });
                    if (bgImage) output.box.background = `url('${bgImage}')`;
                    if (imgSettings.imagePosition === 'left' || imgSettings.imagePosition === 'right') output.boxClasses += ' count-image-left-right';
                }
                if (countBoxHeight) output.box.height = countBoxHeight;
                return output;
            };
            this.config.countSeries.forEach((series) => {
                let seriesArray = [];
                series.countList.forEach((countItem) => {
                    seriesArray.push(setCountItemStyle(countItem));
                });
                output.push(seriesArray);
            });
            return output;
        },
        countBoxContainerClasses() {
            return this.config.countBoxArrangement === 'vertical' ? 'vertical-countboxes' : '';
        },
    },
    methods: {
        async onLoad() {
            if (!this.configStore.datasetList) {
                await configStore.getDatasetList();
            }
            this.datasetsLoaded = true;
        },
        pointClick(pointData) {
            let si = pointData.seriesIndex;
            let pi = pointData.pointIndex;
            if (typeof si !== 'undefined' && typeof pi !== 'undefined') {
                let dataPoint = this.config.countSeries[si].countList[pi];
                this.selectPoint(dataPoint);
            }
        },
        selectPoint(dataPoint) {
            if (dataPoint.clickAction) {
                if (Array.isArray(dataPoint.clickAction)) {
                    actionStore.runChainedActions(dataPoint.clickAction);
                } else if (dataPoint.clickAction.action) {
                    if (dataPoint.clickAction.action === 'layoutProperty') {
                        let prop = dataPoint.clickAction.params.prop;
                        let val = dataPoint.clickAction.params.val;
                        if (dataPoint.clickAction.params && dataPoint.clickAction.params.type === 'toggleBoolean') {
                            this.$store.state[this.parentStoreId][prop] = !this.$store.state[this.parentStoreId][prop];
                        } else this.$store.state[this.parentStoreId][prop] = val;
                    } else actionStore[dataPoint.clickAction.action](dataPoint.clickAction.params);
                }
            }
        },
        popupChart() {
            let parent = this;
            let dialogContent = {
                name: "chart-preview-popup",
                template: `
                    <div>
                    <component :is="config.cType" :cId="config.cId"></component>
                    </div>`,
                data() {
                    return {
                        config: parent.config
                    };
                }
            };
            let title = this.config.chartTitle;
            library.showDialog(dialogContent, false, false, { title: title, showAsAlert: true });
        },
        formatChartData(seriesData) {
            let outputData = {};
            if (!seriesData) seriesData = this.seriesData;
            this.condensedDisplayData = [];
            // Helper functions
            let seriesPercentValues = (rootData, percentTotals, mode) => {
                let output = {};
                for (let sKey in rootData) {
                    let series = rootData[sKey];
                    if (typeof output[sKey] !== 'number') output[sKey] = 0;
                    series.forEach((sItem) => {
                        if (mode === 'get') output[sKey] += Number(sItem.pointValue);
                        else if (mode === 'set') sItem.pointValue /= percentTotals[sKey];
                    });
                }
                return output;
            };
            let parseLogicValue = (countItem) => {
                let iOutput = 0;
                let filteredSeries = [];
                let seriesRecords = typeof seriesData[countItem.logicDataset + '::logic'] === 'object'
                    && Object.values(seriesData[countItem.logicDataset + '::logic']);
                if (countItem.logicDataset && seriesRecords && seriesRecords.length) {
                    filteredSeries = seriesRecords.filter((record) => library.logicParser.call(this, countItem.logicValue, record));
                }
                if (countItem.valueType === 'calcValue' && countItem.calculatedValue && countItem.calculatedValue.length) {
                    iOutput = library.calcParser.call(filteredSeries, countItem.calculatedValue);
                } else {
                    let countVal = 0;
                    let sKey = Array.isArray(countItem.summaryKey) ? countItem.summaryKey[0] : countItem.summaryKey;
                    if (!sKey) {
                        return countVal;
                    }
                    let colSum = sKey.indexOf('::COL_SUM') !== -1;
                    let sumField = sKey.split('::')[1];
                    if (colSum) {
                        filteredSeries.forEach((record) => {
                            if (record[sumField]) countVal += Number(record[sumField]);
                        });
                        iOutput = Number(countVal);
                    } else {
                        iOutput = filteredSeries.length;
                    }
                }
                return iOutput;
            };
            let parsePointValue = (countItem) => {
                let output = {
                    pointLabel: countItem.countTitle || 'No Label',
                    pointValue: 0,
                    labelFormat: countItem.labelFormat
                };
                let pointValue;
                if (countItem.valueType === 'staticValue' && countItem.staticValue) {
                    pointValue = countItem.staticValue;
                } else if (countItem.valueFilter === 'yes' && countItem.logicValue) {
                    pointValue = parseLogicValue(countItem);
                } else if (countItem.valueType === 'calcValue' && countItem.calculatedValue && countItem.calculatedValue.length) {
                    pointValue = library.calcParser.call(seriesData, countItem.calculatedValue);
                } else {
                    let sKey = Array.isArray(countItem.summaryKey) ? countItem.summaryKey[0] : countItem.summaryKey;
                    if (!sKey) {
                        output.pointValue = 0;
                        return output;
                    }
                    let colSum = sKey.indexOf('::COL_SUM') !== -1;
                    let woValIndex = sKey.indexOf('WITHOUT_VALUE') !== -1 ? 'WITHOUT_VALUE' : false;
                    let wValIndex = sKey.indexOf('WITH_VALUE') !== -1 ? 'WITH_VALUE' : false;
                    let withWithoutVal = woValIndex || wValIndex;
                    let sumKeyParts = sKey.split('::');
                    if (colSum) {
                        let propKey = '["' + sKey + '"]';
                        let countVal = library.getByPath(seriesData, propKey);
                        pointValue = Number(countVal);
                    } else if (withWithoutVal) {
                        let propKey = '["' + sKey + '"].' + withWithoutVal;
                        propKey = propKey.replace('::WITHOUT_VALUE', '::columnSummary');
                        propKey = propKey.replace('::WITH_VALUE', '::columnSummary');
                        let countVal = library.getByPath(seriesData, propKey);
                        pointValue = Number(countVal);
                    } else if (sumKeyParts.length > 2) { // NOSONAR
                        let propKey = '["' + sKey + '"].VALUES["' + countItem.summaryValue + '"]';
                        let countVal = library.getByPath(seriesData, propKey);
                        pointValue = Number(countVal);
                    } else pointValue = Number(seriesData[sKey]);
                }
                output.pointValue = isNaN(pointValue) ? '---' : pointValue;
                if (this.config.type === 'Pie' && this.config.pieSettings.dataLabel && this.config.pieSettings.dataLabel.name === 'customLabel' && this.config.pieSettings.dataLabel.customLabelFormat) {
                    let iPointValue = this.dataFormat === 'number' ? Number(output.pointValue).toLocaleString('en') : output.pointValue;
                    let label = this.config.pieSettings.dataLabel.customLabelFormat.replace(/{value}/g, iPointValue).replace(/{label}/g, output.pointLabel);
                    output.customLabel = label;
                }
                return output;
            };
            // Process data
            if (Array.isArray(this.config.countSeries)) {
                this.config.countSeries.forEach((series, index) => {
                    // Collect item data
                    let seriesItemData = [];
                    if (Array.isArray(series.countList)) {
                        series.countList.forEach((countItem) => {
                            let dataItem = parsePointValue(countItem);
                            seriesItemData.push(dataItem);
                            if (countItem.displayWhenCondensed) this.condensedDisplayData.push(dataItem);
                        });
                    } else {
                        // Add seriesData from data passed through props
                        for (let i in this.seriesData) {
                            if (i === 'length') continue;
                            seriesItemData.push({
                                pointLabel: i,
                                pointValue: Number(this.seriesData[i])
                            });
                        }
                    }
                    // Push data to state property
                    outputData['series_' + index] = seriesItemData;
                });
                if (this.dataFormat === 'percent') {
                    // Get Totals
                    let totalCounts = seriesPercentValues(outputData, false, 'get');
                    // Set series pointValue to be the percent of total
                    seriesPercentValues(outputData, totalCounts, 'set');
                }
            }
            return outputData;
        },
        getRequestTypes() {
            let output = {
                sum: {},
                lbeSum: {},
                summary: {},
                rowCount: {},
                logic: {}
            };
            this.config.countSeries.forEach((series) => {
                if (!Array.isArray(series.countList)) return;
                series.countList.forEach((cItem) => {
                    // Get the dataset details, it will determine how we setup the request
                    let sKey;
                    let hasValueFilter = cItem.valueFilter && cItem.valueFilter === 'yes';
                    if (cItem.logicDataset && hasValueFilter) sKey = cItem.logicDataset;
                    else sKey = Array.isArray(cItem.summaryKey) ? cItem.summaryKey[0] : cItem.summaryKey;
                    if (!sKey) return;
                    let sParts = sKey.split('::');
                    let dsId = sParts[0];
                    let field = sParts[1];
                    let currDataset = this.configStore && Array.isArray(this.configStore.datasetList) ? this.configStore.datasetList.find((dataset) => dataset.dsId === dsId) : false;
                    if (!currDataset) return;
                    if (hasValueFilter) output.logic[dsId] = true;
                    if (
                        cItem.summaryValue
                        || sKey.indexOf('::WITHOUT_VALUE') > -1
                        || sKey.indexOf('::WITH_VALUE') > -1
                    ) {
                        output.summary[dsId] = true;
                    }
                    if (sKey.indexOf('::COL_SUM') > -1) {
                        if (currDataset.isLogBook) {
                            output.lbeSum[dsId] = true;
                        } else {
                            if (!output.sum[dsId]) output.sum[dsId] = {};
                            output.sum[dsId][field] = true;
                        }
                    }
                    if (cItem.summaryValue && cItem.summaryValue.indexOf('::rowCount') > -1) {
                        output.rowCount[dsId] = true;
                    }
                });
            });
            return output;
        },
        pointRender: function (args) {
            if (this.config.useDefaultColors !== false) return;
            const seriesColor = [];
            if (
                this.config.countSeries
                && this.config.countSeries.length
                && this.config.countSeries[0].countList
                && this.config.countSeries[0].countList.length
            ) {
                this.config.countSeries[0].countList.forEach((countItem) => {
                    seriesColor.push(countItem.countBackgroundColor);
                });
            }
            args.fill = seriesColor[args.point.index];
        },
        getImagePosition(imgSettings) {
            if (!imgSettings || !imgSettings.imageFile) return false;
            if (imgSettings.imagePosition === 'above' || imgSettings.imagePosition === 'left') {
                return 'topLeft';
            }
            if (imgSettings.imagePosition === 'below' || imgSettings.imagePosition === 'right') {
                return 'bottomRight';
            }
            return 'background';
        }
    },
    components: {
        settingsEditor,
        "ejs-chart": defineAsyncComponent(() => import('@common/syncfusion/chart')),
        "e-series-collection": SeriesCollectionDirective,
        "e-series": SeriesDirective,
        "ejs-accumulationchart": defineAsyncComponent(() => import('@common/syncfusion/accumulationChart')),
        "e-accumulation-series-collection": AccumulationSeriesCollectionDirective,
        "e-accumulation-series": AccumulationSeriesDirective
    },
    beforeUnmount() {
        if (
            this
            && this.cId
            && this.$refs
            && this.$refs[this.cId]
            && this.$refs[this.cId].ej2Instances
            && typeof this.$refs[this.cId].ej2Instances.destroy === 'function')
        {
            this.$refs[this.cId].ej2Instances.destroy();
        }
    }
};

componentStore.initComponent(chartCmp, chartConfig, '@common/chart/chart.vue');
export { chartConfig, chartCmp };
export default chartCmp;
</script>

<style scoped>
.chart {
    overflow: visible;
    min-height: 100px;
    position: relative;
    width: 100%;
}
.chart .chart-title {
    text-align: center;
    color: rgb(66, 66, 66);
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    text-anchor: middle;
    transform: none;
    opacity: 1;
    dominant-baseline: auto;
}
.chart #container, .chart #container_svg {
    overflow: visible !important;
}
.chart .count-box-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}
.count-box-container > div {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 0;
    flex: 1 1 0;
}
.count-box-item-count {
    white-space: nowrap;
}

.vertical-countboxes {
    flex-direction: column;
}
.count-box-container.vertical-countboxes > div {
    flex: 0;
}
.horizontal-count-info {
    display: flex;
}
.chart-count-box.count-image-left-right {
    display: flex;
}
.count-box-text-container {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
}
.count-box-item-count {
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: center;
}
.horizontal-count-info > .count-box-text-container {
    min-width: 50px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
.chart .chart-count-box.horizontal-count-info .count-box-item-label {
    flex-grow: 1;
    justify-content: left;
}
.chart .chart-count-box {
    background: transparent;
    margin: 4px;
    text-align: center;
    min-width: fit-content;
    max-width: 100%;
    cursor: pointer;
    overflow: hidden;
}
.chart .chart-count-box.horizontal-count-info {
    text-align: unset;
}
.count-box-container > div.horizontal-count-info {
    flex-direction: row;
}
.chart .chart-count-box .count-box-item-label {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    padding: 10px;
    min-height: 34px;
    min-width: 125px;
}
.chart .chart-count-box.horizontal-count-info .count-sub-title {
    padding-left: 10px;
    font-size: 14px;
}
.empty-count {
    height: 68px;
}

.condensed-chart {
    padding: 0;
    min-height: auto;
    background: transparent;
}
.condensed-data-point {
    display: inline-block;
    cursor: pointer;
    background: #eee;
    padding: 5px 10px;
    border-radius: 4px;
    font-size: 18px;
    font-weight: bold;
}
.count-item-btn-link {
    text-decoration: underline;
    font-weight: bold;
    border: 0 none;
    background: transparent;
}
</style>
